import { render, staticRenderFns } from "./IssueDetailHeaderPc.vue?vue&type=template&id=0cd079ef&scoped=true&"
import script from "./IssueDetailHeaderPc.vue?vue&type=script&lang=ts&"
export * from "./IssueDetailHeaderPc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd079ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VIcon,VSpacer,VToolbar})
